import { useCallback, useEffect, useRef, useState } from "react";
import { updateCrmPreferenceApi } from "../../../api/userApi";
import { errorDetail } from "../../../helper/errorDetail";
import { parseCrmStepAnswer } from "./crmStep";

export default function useCrmPreferenceAnswer({ step, setBusy, commitAnswer, handleClarify }) {
  const [error, setError] = useState("");
  const mounted = useRef(false);
  const pending = useRef(false);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  useEffect(() => { setError(""); }, [step]);

  const submit = useCallback(async (selection, text) => {
    if (pending.current) return;
    const parsed = parseCrmStepAnswer(selection, text);
    if (!parsed.ok) { handleClarify(); return; }
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      await updateCrmPreferenceApi(parsed.value.crmPreference);
      if (mounted.current) commitAnswer(parsed, parsed.display);
    } catch (requestError) {
      if (mounted.current) {
        setError(errorDetail(requestError?.response?.data?.detail, "Your CRM preference could not be saved. Please try again."));
        setBusy(false);
      }
    } finally {
      pending.current = false;
    }
  }, [commitAnswer, handleClarify, setBusy]);

  return { submit, error };
}
